<app-title title=" {{ 'PAGINA_PLANO.TITULO' | translate }}"></app-title>

<!-- Cabeçalho -->
<section>
  <div
    class="n-container p-5 n-card2 flex flex-wrap flex-column md:flex-row md:justify-content-between row-gap-5 column-gap-4"
  >
    <div>
      <h4>{{ 'PAGINA_PLANO.ID' | translate }}</h4>
      <p>{{plano.id}}</p>
    </div>
    <div>
      <h4>{{ 'PAGINA_PLANO.NOME' | translate }}</h4>
      <p>{{plano.nome}}</p>
    </div>
    <div>
      <h4>{{ 'PAGINA_PLANO.APLICACAO' | translate }}</h4>
      <p>{{plano.aplicacao}}</p>
    </div>
    <div>
      <h4>{{ 'PAGINA_PLANO.STATUS' | translate }}</h4>
      <p>{{plano.status}}</p>
    </div>

    <!-- <p-button label="Salvar" type="submit" /> -->
  </div>
</section>

<section class="section-margin">
  <form
    [formGroup]="formBuscarFuncionalidade"
    class="n-form"
    (ngSubmit)="buscarFuncionalidadesPlano()"
  >
    <div
      class="n-container p-5 n-card2 flex flex-wrap flex-column md:flex-row md:justify-content-between row-gap-5 column-gap-4"
    >
      <p-floatLabel>
        <p-inputNumber inputId="integeronly" formControlName="id" id="id" />
        <label for="id" class="ng-invalide"
          >{{ 'PAGINA_PLANO.ID' | translate }}</label
        >
      </p-floatLabel>
      <p-floatLabel>
        <input pInputText id="nome" formControlName="nome" />
        <label for="id" class="ng-invalide"
          >{{ 'PAGINA_PLANO.NOME' | translate }}</label
        >
      </p-floatLabel>
      <p-button label="Pesquisar" type="submit" />
    </div>
  </form>
</section>
<!-- Tabela com funcionalidades vinculadas ao plano -->
<section class="section-margin">
  <div class="n-container p-5 n-card2">
    <div>
      <div class="flex justify-content-end">
        <h4>R$ {{total}}</h4>
        <button
          type="button"
          pButton
          pRipple
          icon="pi pi-plus"
          (click)="showAddFuncionalidadeDialog()"
        ></button>
      </div>
      <p-table [value]="funcionalidadesPlano" [tableStyle]="{'min-width': '50rem'}">
        <ng-template pTemplate="header" let-columns>
          <tr>
            <th>{{ 'PAGINA_PLANO.ID' | translate }}</th>
            <th>{{ 'PAGINA_PLANO.NOME' | translate }}</th>
            <th>{{ 'PAGINA_PLANO.VALOR' | translate }}</th>
            <th>{{ 'PAGINA_PLANO.ACOES' | translate }}</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-funcionalidade let-columns="columns">
          <tr>
            <td>{{funcionalidade.id}}</td>
            <td>{{funcionalidade.nome}}</td>
            <td>{{funcionalidade.valor}}</td>
            <td class="flex gap-2">
              <button
                type="button"
                pButton
                pRipple
                icon="pi pi-pencil"
                (click)="showEditarFuncionalidadeDialog(funcionalidade)"
              ></button>
              <button
                type="button"
                pButton
                pRipple
                icon="pi pi-trash"
                (click)="desvincularFuncionalidade(funcionalidade)"
              ></button>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</section>

<app-voltar></app-voltar>

<!-- Modal Adicionar funcionaliade -->

<p-dialog
  header="Adicionar funcionalidade"
  [modal]="true"
  [(visible)]="showAddFuncionalidade"
  [style]="{ width: '50rem' }"
>
  <div>
    <p-table [value]="funcionalidades" [(selection)]="funcionalidadesSelecionadas" [tableStyle]="{'min-width': '50rem'}">
      <ng-template pTemplate="header" let-columns>
        <tr>
          <th style="width: 4rem"><p-tableHeaderCheckbox /></th>
          <th>{{ 'PAGINA_PLANO.ID' | translate }}</th>
          <th>{{ 'PAGINA_PLANO.NOME' | translate }}</th>
          <th>{{ 'PAGINA_PLANO.VALOR' | translate }}</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-funcionalidade let-columns="columns">
        <tr>
          <td>
            <p-tableCheckbox [value]="funcionalidade" />
        </td>
          <td>{{funcionalidade.id}}</td>
          <td>{{funcionalidade.nome}}</td>
          <td>R$ {{funcionalidade.valor}}</td>
        </tr>
      </ng-template>
    </p-table>

  </div>

  <div class="flex justify-content-end gap-2">
    <p-button
      label="Cancel"
      severity="secondary"
      (onClick)="showAddFuncionalidade = false"
    />
    <p-button label="Save" type="submit" (onClick)="salvarFuncionalidade()" />
  </div>
</p-dialog>
